var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 304.18 30.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u05E2\\u05DC\\u05D9\\u05E0\\u05D5",
    "data-name": "\\u05E2\\u05DC\\u05D9\\u05E0\\u05D5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.81,9.07H0V.94h27.02v28.2h-9.21V9.07ZM.33,14.24h9.21v14.9H.33v-14.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.73,9.07h-7.28v20.07h-14v-8.13h4.79v-11.94h-3.38V.94h29.09v28.2h-9.21V9.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.73.94h9.21v28.2h-9.21V.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.6,29.14h-9.21v-14.1c0-8.74,6.49-15.04,15.32-15.04s15.18,6.3,15.18,15.04c0,12.31-9.12,17.25-18.99,13.49l2.26-7.57c3.9,1.5,7.52-.23,7.52-5.92,0-3.85-2.54-6.58-5.97-6.58s-6.11,2.73-6.11,6.58v14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.07.94v28.2h-27.87v-8.13h4.89V.94h9.21v20.07h4.56V.94h9.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.44.94h9.21v15.51h-9.21V.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.37,30.08c-4.09,0-8.65-1.97-11.37-5.5l6.16-5.31c1.13,1.41,3.01,2.35,4.56,2.35,3.34,0,6.02-2.73,6.02-6.58s-2.68-6.58-6.02-6.58c-1.55,0-3.43.94-4.56,2.35l-6.16-5.31c2.73-3.52,7.28-5.5,11.37-5.5,8.93,0,14.48,6.49,14.48,15.04s-5.55,15.04-14.48,15.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.52,29.14h-9.21v-14.1c0-8.74,6.49-15.04,15.32-15.04s15.18,6.3,15.18,15.04c0,12.31-9.12,17.25-18.99,13.49l2.26-7.57c3.9,1.5,7.52-.23,7.52-5.92,0-3.85-2.54-6.58-5.97-6.58s-6.11,2.73-6.11,6.58v14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.18,15.04c0-8.55,6.34-15.04,15.04-15.04s14.99,6.49,14.99,15.04-6.34,15.04-14.99,15.04-15.04-6.49-15.04-15.04ZM254.22,21.62c3.34,0,5.78-2.77,5.78-6.58s-2.44-6.58-5.78-6.58-5.83,2.77-5.83,6.58,2.44,6.58,5.83,6.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282.89,29.14h-9.21v-14.1c0-8.74,6.49-15.04,15.32-15.04s15.18,6.3,15.18,15.04c0,12.31-9.12,17.25-18.99,13.49l2.26-7.57c3.9,1.5,7.52-.23,7.52-5.92,0-3.85-2.54-6.58-5.97-6.58s-6.11,2.73-6.11,6.58v14.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdpi);
export default __webpack_public_path__ + "static/media/מסמכי עמותהmdpi.ea91d7e2a1864c3f6a8aa0a3bc8364ca.svg";
export { ForwardRef as ReactComponent };